/* src/app/components/filedetails/filedetails.component.scss */
h2 {
  margin-top: 0px;
}
.extra-top-space {
  margin-top: 25px;
}
.status .status-block {
  height: 30px;
  width: 30px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}
.status h2 {
  position: absolute;
  top: 25px;
  left: 50px;
}
.break-long-words {
  word-break: break-word;
}
/*# sourceMappingURL=filedetails.component.css.map */
